<div id="wrapper">
    <app-loading-screen [status]="this.statusLoader"></app-loading-screen> 
        <div class="allcont">
          <app-menu [tabActive]="this.tabActive"></app-menu>
          <app-loading-screen></app-loading-screen>
          <div class="basicrow mbott">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle">
                    <span class="icon-dash-14"></span> Mis Cuentas 
                </div>
                <div class="basicrow m-top mbott-gift"> 
                    <div class="basicrow f-black roboto-r f-reg m-top-ii">
                        <div class="autowcont">
                            <div class="basicrow">
                                <div class="basicrow allpads">
                                    Estas son las cuentas que le son facturadas. Si hay alguna que dio de baja recientemente y no desea tenerla disponible puede removerla. Si por lo contrario, suscribió una nueva cuenta y no se encuentra en la lista puede incluirla utilizando la sección Agregar Cuentas.
                                </div>
                                <div class="addAcounts" *ngIf="this.addUsersView==true;">
                                    Añadir Cuentas:
                                </div>
                                <div class="allpads" *ngIf="this.addUsersView==true;">
                                    Para a&ntilde;adir una cuenta, provea el n&uacute;mero de cuenta seg&uacute;n aparece en la factura (BAN por sus siglas en ingl&eacute;s) y los &uacute;ltimos 4 digitos del seguro Social del due&ntilde;o de la misma.
                                </div>
                                
                                <div class="basicrow text-center activateAddAccount" *ngIf="this.addUsersView==false;">
                                    <a  data-toggle="collapse" data-target="#collapseAddAccount"(click)="this.unCollapse();" *ngIf="this.addUsersView==false;"  class="btns def-iv red centr vcenter">
                                        <span class="tabcell">
                                            Agregar Cuentas
                                        </span>
                                    </a>
                                </div>
                                <div id="collapseAddAccount" class="collapse" >
                                    <div class="basicrow msidespad m-top-ii text-center">
                                        <div class="shortcont">
                                            <div class="basicrow">
                                                <div class="basicrow">
                                                    <label class="label-f">
                                                        N&uacute;mero de Cuenta
                                                    </label>
                                                    <input class="inp-f" [(ngModel)]="this.accountId" maxlength="9" numbers-only>
                                                </div>
                                                <div class="basicrow m-top-i">
                                                    <label class="label-f">
                                                        4 &uacute;ltimos n&uacute;meros del Seguro Social
                                                    </label>

                                                    <input class="inp-f"  [(ngModel)]="this.ssn" maxlength="4" numbers-only type="password">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="basicrow m-top-ii allpads">
                                        <div class="basicrow">
                                            <div class="logline full"></div>
                                        </div>
                                        <div class="basicrow m-top-i">
                                            Las Cuentas marcadas como Principal ser&aacute; preseleccionada por el sistema en todos los procesos donde se solicite una cuenta. Solo una Cuenta puede ser configurada como principal.
                                        </div>
                                        <div class="basicrow m-top-i roboto-b text-center">
                                            <input [(ngModel)]="this.markMainAccount" id="markMainAccount" type="checkbox"> Marcar esta cuenta como principal
                                        </div>
                                        <div class="basicrow m-top-i">
                                            <div class="logline full"></div>
                                        </div>
                                        <div class="basicrow m-top-i text-center visible-web">
                                            <div class="centerButtons">
                                                <div class="btm-left">
                                                    <a (click)="this.collapse();"  data-toggle="collapse" data-target="#collapseAddAccount" class="btns def-i gray vcenter">
                                                        <span class="tabcell">
                                                            Cancelar
                                                        </span>
                                                    </a>
                                                </div>
                                                <div class="btm-right">
                                                    <a (click)="this.addAccount();" class="btns def-iv red vcenter right">
                                                        <span class="tabcell" >
                                                            Guardar Cuenta&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="basicrow m-top-i text-center visible-movil">
                                            <div class="centerButtons">
                                                <a (click)="this.collapse();"  data-toggle="collapse" data-target="#collapseAddAccount" class="btns btn-mov-b gray  vcenter">
                                                        <span class="tabcell">
                                                            Cancelar
                                                        </span>
                                                </a>
                                                <a (click)="this.addAccount();" class="btns top-btn-mov btn-mov-b red  vcenter">
                                                    <span class="tabcell" >
                                                        Guardar Cuenta&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="basicrow m-top visible-web" >
                                        <div class="boxtbl">
                                            <div class="tab-tbar">
                                                <div class="frwds trds1 rline vcenter">
                                                    <div class="tabcell">
                                                        N&uacute;mero de Cuenta
                                                    </div>
                                                </div>
                                                <div class="frwds trds1 rline vcenter">
                                                    <div class="tabcell">
                                                        Nombre de Empresa
                                                    </div>
                                                </div>
                                                <div class="frwds trds1 rline vcenter">
                                                    <div class="tabcell">
                                                        Fecha de Asociaci&oacute;n
                                                    </div>
                                                </div>
                                                <div class="frwds trds1 vcenter">
                                                    <div class="tabcell">
                                                        Tipo
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                        
                                        <div class="basicrow"  *ngFor="let account of this.offers['offers']; let i = index">
                                            <div class="estella">
                                                <i class="fa fa-star on" *ngIf="account.offers[0].defaultAccount=='Y'"></i>
                                                <i class="fa fa-star-o" *ngIf="account.offers[0].defaultAccount=='N'" (click)="this.mainAccountChange(true,account.offers[0].ban,account.offers[0].productType,account.offers[0].accountType,account.offers[0].accountSubType,i);"></i>
                                            </div>
                                            <div data-toggle="collapse" [attr.data-target]="'#collapse-'+i" class="digs-box add-acc" (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i] == true,'': this.expand[0] == false}">
                                                <div class="add-acc-ban2 vcenter">
													<div class="tabcell">
														<span class="roboto-m espacioBan">{{account.offers[0].ban}}</span>
													</div>
												</div>
												<div class="roboto-m add-acc-name2 vcenter">
													<div class="tabcell">
                                                        {{account.offers[0].userName}}
													</div>
												</div>
												<div class="add-acc-date2 vcenter pleft-a">
													<div class="tabcell">
														<span class="roboto-m">{{account.offers[0].registerDate}}</span>
													</div>
                                                </div>
                                                <div class="add-acc-date2 vcenter pleft-a">
													<div class="tabcell">
                                                        <span class="roboto-m">{{account.offers[0].productType}}</span>     
                                                        <i class="fa fa-minus" aria-hidden="true" style="float:right"></i>
                                                        <i class="fa fa-plus" aria-hidden="true" style="float:right"></i>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="collapse-{{i}}" class="collapse">
                                                    <div class="basicrow pad-rad tabtopb f-black roboto-r f-reg">
                                                        <div class="basicrow roboto-b associatedTelephones">
                                                            Tel&eacute;fonos Asociados
                                                        </div>                                                    
                                                        <div class="accs-telfs m-top-i m-radio-top" *ngFor="let value of account.offers[0].offers; let k = index" >
                                                            <div style="width: 20%; float: left;">
                                                                <mat-radio-group name="group" [(ngModel)]="this.defaultSubcriber">
                                                                    <mat-radio-button  class="radio-a" name="opciones" [value]="value">{{value}}</mat-radio-button>
                                                                </mat-radio-group> 
                                                            </div>
                                                        </div>
                                                       <div class="basicrow m-top-i">
                                                            <div class="logline full"></div>
                                                       </div>
                                                        <div class="basicrow m-top-i m-bott-ii text-center">
                                                            <a *ngIf="account['offers'][0].defaultAccount=='N'"  class="btmWeb btns def-i gray pull-left vcenter" (click)="this.deleteAccount(account['offers'][0].ban,i);">
                                                                <span class="tabcell">
                                                                    Eliminar
                                                                </span>
                                                            </a>
                                                            <a  class="btmWeb btns def-i red pull-right vcenter" (click)="this.mainAccountChange(false,account['offers'][0].ban,account['offers'][0].productType,account['offers'][0].accountType,account['offers'][0].accountSubType,i);">
                                                                <span class="tabcell">
                                                                    Guardar Cambios&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <div  class="thereIsNoData" *ngIf="this.offers['offers']?.length < 0">
                                            No hay datos disponible para esta cuenta.
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
      </div>